import React from 'react';
import { ClockIcon, ThermometerSnowflakeIcon, MessageSquareIcon, RouteIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { whyCards } from '../data/site';
const icons = [ClockIcon, ThermometerSnowflakeIcon, MessageSquareIcon, RouteIcon];
export function WhyHoldFast() {
  return <section className="w-full border-y border-line bg-white py-24 lg:py-32" data-id="element-340" data-mp="1fsck1h6i0qlf">
      <div className="mx-auto max-w-[1280px] px-6 lg:px-10" data-id="element-341" data-mp="1jtfzi2kmwkm4">
        <Reveal data-id="element-342" data-mp="1jt6aoibbsji0">
          <p className="flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.24em] text-ice" data-id="element-343" data-mp="1jvshugub0wzp">
            <span className="h-px w-8 bg-ice" aria-hidden="true" data-id="element-344" data-mp="1trm3qqtwy2u5" />
            Why Hold Fast
          </p>
          <h2 className="mt-6 max-w-2xl font-display text-3xl font-extrabold leading-[1.05] tracking-tightest text-ink sm:text-4xl lg:text-[3.1rem]" data-id="element-345" data-mp="1yqp0lnzqp2r1">
            When the Load Matters, Hold Fast.
          </h2>
        </Reveal>

        <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-346" data-mp="4bw5rr6okg05">
          {whyCards.map((card, i) => {
          const Icon = icons[i];
          return <li key={card.title} className="h-full" data-id="element-347" data-mp="26312tx0t7u89" data-mpi={i}>
                <Reveal delay={0.04 * i} className="h-full" data-id="element-348" data-mp="261gcykpfwzgq">
                  <div className="group flex h-full flex-col rounded-2xl border border-line bg-mist p-8 transition-[transform,border-color,background-color,box-shadow] duration-200 ease-premium hover:-translate-y-1.5 hover:border-ice/40 hover:bg-white hover:shadow-[0_18px_50px_rgba(11,14,17,0.09)]" data-id="element-349" data-mp="213eotld5q9ye">
                    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-ice transition-transform duration-200 ease-premium group-hover:scale-110 group-hover:bg-ice-100" data-id="element-350" data-mp="2ot9387d4k6kr">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-351" data-mp="2ftm3rr3yhauc" />
                    </span>
                    <h3 className="mt-6 font-display text-lg font-bold uppercase leading-tight tracking-tight text-ink" data-id="element-352" data-mp="18fix6v2g388h">
                      {card.title}
                    </h3>
                    <p className="mt-3 text-sm leading-relaxed text-ink-soft" data-id="element-353" data-mp="15v4704vtj042">{card.detail}</p>
                  </div>
                </Reveal>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}